import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text, Textarea } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { SquareChartGantt } from 'lucide-react'
import { getNestedError, MAX_BODY_LENGTH, MAX_BODY_LINES } from '../utils'

interface BodyFieldProps {
  keyName: string
  label: string
  placeholder: string
  enableValidation?: boolean
}

export const BodyField = ({ keyName, label, placeholder, enableValidation = true }: BodyFieldProps) => {
  const { register, errors } = useFormContext()
  const t = useLocaleText(label, true)
  const t_placeholder = useLocaleText(placeholder, true)
  const error_body = useLocaleText('error_body', true)
  const error_prompt = useLocaleText('error_prompt', true)
  const error_body_max_length = useLocaleText('error_body_max_length', true)
  const error_body_max_lines = useLocaleText('error_body_max_lines', true)
  const error = getNestedError(errors, keyName)

  const validationRules = {
    required: enableValidation ? error_body : error_prompt,
    ...(enableValidation && {
      maxLength: {
        value: MAX_BODY_LENGTH,
        message: error_body_max_length,
      },
      validate: {
        maxLines: (value: string) => {
          if (!value) return true
          const lines = value.split('\n').length
          return lines <= MAX_BODY_LINES || error_body_max_lines
        },
      },
    }),
  }

  return (
    <StyledFormControl isInvalid={!!error}>
      <StyledFormLabel required>
        <SquareChartGantt size={18} strokeWidth={2.5} />
        <Text>{t}</Text>
      </StyledFormLabel>

      <Textarea
        name={keyName}
        ref={register(validationRules)}
        minH={{ base: '80px', md: '118px' }}
        borderRadius="5px"
        bg="white"
        resize="none"
        border="1px solid"
        placeholder={t_placeholder}
        _focus={{ boxShadow: '0px 0px 0px 1px black' }}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
